module.exports = __webpack_public_path__ + "img/banner.5750596b.jpg";